import React, { useState } from 'react';
import Sidebar_Progress from "../../../layouts/Operational_Sidebar_Progress.component";
import ReactDOM from 'react-dom';
import { API_URL } from "../../../../constant/API_Settings";
import swal from "sweetalert";
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { Link } from "react-router-dom";
import Modal from "react-modal";
import Loader from "../../../Loader/Loader";
import ManagerLoginHeader from '../../Manager/ManagerLoginHeader.component'

const InvoiceSettingsConfig = (props) => {

  const [inputValues, setInputValues] = useState({
    invoice_address: "",
    gst_no: "",
    dealer: "",
    place: "",
   /* bill_no: ""*/
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [lastNfDirectBillNo, setLastNfDirectBillNo] = useState(null);
  const [nextNfDirectBillNo, setNextNfDirectBillNo] = useState(null);

  // ✅ Load existing invoice settings
  useEffect(() => {
    loadInvoiceSettings();
  }, []);

  const loadInvoiceSettings = () => {
    setLoading(true);

    fetch(`${API_URL}/invoice-settings/show`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true && data.data) {
          setInputValues({
            invoice_address: data.data.invoice_address || "",
            gst_no: data.data.gst_no || "",
            dealer: data.data.dealer || "",
            place: data.data.place || "",
           /* bill_no: data.data.bill_no || "",*/
            
          });
         /* setLastNfDirectBillNo(
            data.data.last_nf_direct_bill_no != null ? data.data.last_nf_direct_bill_no : null
          );
          setNextNfDirectBillNo(
            data.data.next_nf_direct_bill_no != null ? data.data.next_nf_direct_bill_no : null
          );*/
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  // ✅ Handle input change
  const handleInputs = (e) => {
    const { name, value } = e.target;
    setInputValues(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // ✅ Form validation
  const validateForm = () => {
    let err = {};
    let ok = true;

    if (!inputValues.invoice_address) {
      err.invoice_address = "Enter invoice address";
      ok = false;
    }

    if (!inputValues.gst_no) {
      err.gst_no = "Enter GST number";
      ok = false;
    }
    if (!inputValues.dealer) {
      err.dealer = "Enter Dealer Name";
      ok = false;
    }
    if (!inputValues.place) {
      err.place = "Enter Place of Supply";
      ok = false;
    }
    /* if (!inputValues.bill_no) {
      err.bill_no = "Enter Starting Bill Number";
      ok = false;
    }*/
    setErrors(err);
    return ok;
  };

  // ✅ Save / Update
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    fetch(`${API_URL}/invoice-settings/save`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("AUTH_TOKEN"),
        "Accept": "application/json"
      },
      body: JSON.stringify(inputValues)
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === true) {
          swal("", "Invoice settings saved successfully", "success");
          loadInvoiceSettings();
        } else {
          swal("", "Save failed", "warning");
        }
      })
      .catch(() => swal("", "Server error", "warning"));
  };


  return (
    <div className="main-container page-wrap">
      <div className="d-md-flex">

        <Sidebar_Progress props={props} progress={22} />

        <div className="content-area">
          <ManagerLoginHeader props={props} page_title="Invoice Details" />

          <div className="container pb-3">
            <div className="row mt-md-5 mt-3 justify-content-center form-container">
              <div className="form-wrap col-md-8">

                <h3 className="table-title mb-4">Invoice Details</h3>

                {loading ? (
                   <Loader />
                ) : (
                  <form onSubmit={handleSubmit}>

                    {/* Invoice Address */}
                    <div className="mb-3">
                      <label className="form-label">Invoice Address</label>
                      <textarea
                        name="invoice_address"
                        className="form-control"
                        rows="4"
                        value={inputValues.invoice_address}
                        onChange={handleInputs}
                      />
                      {errors.invoice_address && (
                        <small className="text-danger">{errors.invoice_address}</small>
                      )}
                    </div>

                    {/* GST Number */}
                    <div className="mb-3">
                      <label className="form-label">GST Number</label>
                      <input
                        type="text"
                        name="gst_no"
                        className="form-control"
                        value={inputValues.gst_no}
                        onChange={handleInputs}
                      />
                      {errors.gst_no && (
                        <small className="text-danger">{errors.gst_no}</small>
                      )}
                    </div>
                    {/* Dealer */}
                    <div className="mb-3">
                      <label className="form-label">Dealer</label>
                      <input
                        type="text"
                        name="dealer"
                        className="form-control"
                        value={inputValues.dealer}
                        onChange={handleInputs}
                      />
                      {errors.dealer && (
                        <small className="text-danger">{errors.dealer}</small>
                      )}
                    </div>
                    {/* Place of Supply */}
                    <div className="mb-3">
                      <label className="form-label">Place of Supply</label>
                      <input
                        type="text"
                        name="place"
                        className="form-control"
                        value={inputValues.place}
                        onChange={handleInputs}
                      />
                      {errors.place && (
                        <small className="text-danger">{errors.place}</small>
                      )}
                    </div>
                     {/* Starting Bill Number */}
                    {/*<div className="mb-3">
                      <label className="form-label">Starting Bill Number</label>
                      <input
                        type="number"
                        name="bill_no"
                        className="form-control"
                        value={inputValues.bill_no}
                        onChange={handleInputs}
                      />
                      {errors.bill_no && (
                        <small className="text-danger">{errors.bill_no}</small>
                      )}
                      <div className="form-text text-muted mt-2">
                        Non-fuel direct sales (system bill no.):{" "}
                        {lastNfDirectBillNo != null ? (
                          <>
                            last issued <strong>{lastNfDirectBillNo}</strong>
                            {nextNfDirectBillNo != null && (
                              <> — next will be <strong>{nextNfDirectBillNo}</strong></>
                            )}
                          </>
                        ) : (
                          <>no direct sales with bill numbers yet — next will be <strong>1</strong></>
                        )}
                      </div>
                    </div>*/}

                    <button type="submit" className="btn btn-primary">
                      Save / Update
                    </button>

                  </form>
                )}

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default InvoiceSettingsConfig;
